/**
 * @generated SignedSource<<83ac6f074393d7ca9b554594ab38d164>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ConnectionChoicesQuery$variables = {
  integrationRowId: any;
};
export type ConnectionChoicesQuery$data = {
  readonly integration: {
    readonly config: any | null;
  } | null;
};
export type ConnectionChoicesQuery = {
  variables: ConnectionChoicesQuery$variables;
  response: ConnectionChoicesQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "integrationRowId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "rowId",
    "variableName": "integrationRowId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "config",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConnectionChoicesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Integration",
        "kind": "LinkedField",
        "name": "integration",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConnectionChoicesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Integration",
        "kind": "LinkedField",
        "name": "integration",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7b99847c6866c0aecc6f7843f2948482",
    "id": null,
    "metadata": {},
    "name": "ConnectionChoicesQuery",
    "operationKind": "query",
    "text": "query ConnectionChoicesQuery(\n  $integrationRowId: UUID!\n) {\n  integration(rowId: $integrationRowId) {\n    config\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "980c2a168e17226898e8571f9a3f4511";

export default node;
